// extracted by mini-css-extract-plugin
module.exports = {"bbTourCardImage":"providers-bb-components-BbTourCard-BbTourCardImage-BbTourCardImage__bbTourCardImage--3wehl"};